import Vue from "vue";
import { mapGetters, mapState } from "vuex";

import cepFieldComponent from "@/components/child/form/cepfield.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import ShortcutComponent from "@/components/parent/shortcut/shortcut";
import shortcutComponent from "@/components/parent/shortcut/shortcut.vue";
import { Component } from "@/decorators";
import ClienteEnderecoEntregaModel from "@/models/clienteEnderecoEntregaModel";
import FranquiaModel from "@/models/franquiaModel";
import UsuarioModel from "@/models/usuarioModel";
import VendaModel from "@/models/vendaModel";
import ClienteEnderecoEntregaService from "@/services/clienteEnderecoEntregaService";
import CorreiosService from "@/services/correiosService";
import pacoteEntregaService from "@/services/pacoteEntregaService";
import { AppState, Getters } from "@/store/store";

const clienteEnderecoEntregaService = new ClienteEnderecoEntregaService();
const correiosService = new CorreiosService();

@Component({
    components: {
        comboComponent,
        cepFieldComponent,
        dateTimePickerComponent,
        gridComponent,
        shortcutComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
        ...mapGetters(["GET_FRANQUIA_ATUAL"] as Getters),
    },
})
export default class CalcularFreteComponent extends Vue {
    // State computed props
    GET_FRANQUIA_ATUAL: () => FranquiaModel;
    usuarioLogado: UsuarioModel;

    private shortcutComponent: ShortcutComponent = null;
    private shortcutComponentCotacao: ShortcutComponent = null;

    pacotesOptions = [];

    venda: VendaModel = null;
    dataPostagem: Date = null;
    cepOrigem: string = null;
    cepDestino: string = null;
    pacoteEntregaId: number = null;

    private gridData = [];

    private get gridColumn(): Array<GridColumn> {
        return [
            new GridColumn("servico", "Serviço", GridColumnType.String),
            new GridColumn("valor", "Valor", GridColumnType.Money),
            new GridColumn("dataMaxima", "Data Máxima de entrega", GridColumnType.Date),
        ];
    }

    public async setVenda(venda: VendaModel) {
        this.clear();

        this.venda = venda;

        if (venda.enderecoEntregaId) {
            const enderecoEntregaVenda = await clienteEnderecoEntregaService
                .get(venda.enderecoEntregaId)
                .resolveWithJSON<ClienteEnderecoEntregaModel>()
                .withLoading();

            this.cepDestino = enderecoEntregaVenda.cep;
        }

        this.dataPostagem = venda.dataEntrega;
        this.cepOrigem = this.GET_FRANQUIA_ATUAL().cep;
    }

    public async show() {
        this.shortcutComponent = this.$refs.shortcutComponent as ShortcutComponent;
        this.shortcutComponent.title = this.$t("__.Components.parent.venda.calcularFrete_vue_html.frete").toString();

        this.shortcutComponent.show();
    }

    private async onConfirm() {
        try {
            const isValid = await this.$validator.validateAll();
            if (isValid) {
                this.gridData = await correiosService
                    .getCotacaoFrete({
                        data: this.dataPostagem,
                        cepOrigem: this.cepOrigem,
                        cepDestino: this.cepDestino,
                        dataPostagem: this.dataPostagem,
                        pacoteEntregaId: this.pacoteEntregaId,
                        valorDeclarado: this.venda.valorFinal,
                    })
                    .withLoading()
                    .resolveWithJSON<any>();

                this.shortcutComponent.hide();

                this.shortcutComponentCotacao = this.$refs.shortcutComponentCotacao as ShortcutComponent;
                this.shortcutComponentCotacao.title = this.$t(
                    "__.Components.parent.venda.calcularFrete_vue_html.selecionarCotacao",
                ).toString();
                this.shortcutComponentCotacao.show();
            } else {
                this.$focusErrorField();
            }
        } catch {}
    }

    private onSelectCotacao(data) {
        this.$emit("onSelectCotacao", data);

        this.shortcutComponentCotacao.hide();
    }

    public clear() {
        this.dataPostagem = null;
        this.cepOrigem = null;
        this.cepDestino = null;
    }

    private async mounted() {
        const data = await pacoteEntregaService.comboCached(this.usuarioLogado.franquiaId);

        this.pacotesOptions = data;

        if (data.length == 1) {
            this.pacoteEntregaId = data[0].value;
        }
    }
}
